import { ShieldOff, SearchX, type LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { EmptyState } from '@/components/common/empty-state';
import { Button } from '@/components/ui/button';

function Shell({
  icon,
  title,
  description,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
}) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <EmptyState
        icon={icon}
        title={title}
        description={description}
        className="w-full max-w-lg border-0"
        action={
          <Button asChild variant="outline">
            <Link to="/dashboard">Voltar ao início</Link>
          </Button>
        }
      />
    </div>
  );
}

export function ForbiddenPage() {
  return (
    <Shell
      icon={ShieldOff}
      title="Acesso negado"
      description="Você não tem permissão para acessar esta área. Solicite acesso ao administrador da empresa."
    />
  );
}

export function NotFoundPage() {
  return (
    <Shell
      icon={SearchX}
      title="Página não encontrada"
      description="O endereço acessado não existe ou foi movido."
    />
  );
}
